import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Search, ChevronDown, ArrowUpRight } from "lucide-react";
import { Modal } from "./ui";
export function WorkspaceNavigation({ groups, prefix, mode }) {
  const { pathname } = useLocation();
  const [opened, setOpened] = useState(["Catalogue"]);
  const nav = useRef(null);
  useEffect(() => {
    const activeGroup = groups.find(([, links]) =>
      links.some(
        ([, path]) => pathname === `${prefix}${path ? `/${path}` : ""}`,
      ),
    )?.[0];
    if (activeGroup)
      setOpened((previous) => [...new Set([...previous, activeGroup])]);
  }, [pathname, groups, prefix]);
  return (
    <nav ref={nav} aria-label={`${mode} workspace`}>
      {groups.map(([label, links], i) => {
        const expanded = i === 0 || opened.includes(label);
        return (
          <div
            className={`tb-ops-nav-group ${expanded ? "is-expanded" : ""}`}
            key={label}
          >
            {i !== 0 && (
              <button
                type="button"
                className="tb-nav-section"
                aria-expanded={expanded}
                onClick={() =>
                  setOpened((previous) =>
                    previous.includes(label)
                      ? previous.filter((x) => x !== label)
                      : [...previous, label],
                  )
                }
              >
                <span>{label}</span>
                <ChevronDown size={13} />
              </button>
            )}
            {expanded && (
              <div className="tb-nav-links">
                {links.map(([title, path, Icon]) => (
                  <NavLink
                    end
                    key={path}
                    to={`${prefix}${path ? `/${path}` : ""}`}
                  >
                    <Icon size={17} />
                    <span>{title}</span>
                  </NavLink>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </nav>
  );
}
export function WorkspaceFinder({ groups, prefix }) {
  const [open, setOpen] = useState(false),
    [search, setSearch] = useState("");
  const location = useLocation();
  useEffect(() => setOpen(false), [location.pathname]);
  useEffect(() => {
    const key = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setOpen((v) => !v);
      }
    };
    window.addEventListener("keydown", key);
    return () => window.removeEventListener("keydown", key);
  }, []);
  const results = groups
    .flatMap(([group, links]) =>
      links.map(([title, path, Icon]) => ({ group, title, path, Icon })),
    )
    .filter((x) =>
      `${x.group} ${x.title}`.toLowerCase().includes(search.toLowerCase()),
    );
  return (
    <>
      <button
        className="tb-workspace-finder" aria-label="Find a workspace"
        type="button"
        onClick={() => {
          setSearch("");
          setOpen(true);
        }}
      >
        <Search size={16} />
        <span>Find a workspace</span>
        <kbd>⌘ K</kbd>
      </button>
      {open && (
        <Modal title="Find a workspace" onClose={() => setOpen(false)}>
          <div className="tb-workspace-search">
            <Search size={18} />
            <input
              aria-label="Search workspace pages"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Products, orders, sellers…"
            />
          </div>
          <div className="tb-workspace-results">
            {results.length ? (
              results.map(({ group, title, path, Icon }) => (
                <Link
                  key={path}
                  to={`${prefix}${path ? `/${path}` : ""}`}
                  onClick={() => setOpen(false)}
                >
                  <Icon size={17} />
                  <span>
                    {title}
                    <small>{group}</small>
                  </span>
                  <ArrowUpRight size={14} />
                </Link>
              ))
            ) : (
              <p>No matching workspace. Try “orders” or “products”.</p>
            )}
          </div>
        </Modal>
      )}
    </>
  );
}
